import { Component, Input, OnInit } from '@angular/core';
import { UrlUtils } from '../../../shared/utils/url.utils';
import { Collection } from '../../../shared/interfaces/collection.interface';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { SvgViewboxDirective, HideOnPrintDirective } from '@exl-ng/mulo-core';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'esp-collections-essentials',
    templateUrl: './collections-essentials.component.html',
    styleUrls: ['./collections-essentials.component.scss'],
    imports: [
        MatIcon,
        SvgViewboxDirective,
        RouterLink,
        MatButton,
        HideOnPrintDirective,
        TranslateModule
    ]
})
export class CollectionsEssentialsComponent implements OnInit {
    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() collections: Collection[];

    authorsDetails = false;
    institutionCode = UrlUtils.getParam('institution');

    constructor() {}

    ngOnInit(): void {
    }

    toggleAuthorsDetails() {
        this.authorsDetails = !this.authorsDetails;
    }
}
